export default "__VITE_ASSET__CMD6nhfc__"